// extracted by mini-css-extract-plugin
module.exports = {"dragItem":"styles_dragItem__4T2Lv","draggable":"styles_draggable__S0_NT","highlight":"styles_highlight__uQsLU","date":"styles_date__goTzZ"};